module.exports = __webpack_public_path__ + "img/VKO.c29f1949.png";